/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
// import PresentationView from './views/Presentation';
import PresentationView from './views/DashboardDefault';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/presentation" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login'))
      },
      {
        path: '/auth/register',
        exact: true,
        component: lazy(() => import('src/views/Register'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/adaptive-matching',
        exact: true,
        component: lazy(() => import('src/views/Matching/Adaptive'))
      },
      {
        path: '/audit',
        exact: true,
        component: lazy(() => import('src/views/AuditEvents'))
      },
      {
        path: '/blocking',
        exact: true,
        component: lazy(() => import('src/views/Blocking'))
      },
      {
        path: '/cluster-classification/:id',
        exact: true,
        component: lazy(() =>
          import('src/views/Matching/ClusterClassification')
        )
      },
      {
        path: '/clustering',
        exact: true,
        component: lazy(() => import('src/views/Standardization/Clustering'))
      },
      {
        path: '/custom-fields',
        exact: true,
        component: lazy(() => import('src/views/CustomFields'))
      },
      {
        path: '/custom-field/:id([+-]?\\d+)',
        exact: true,
        component: lazy(() => import('src/views/CustomFields/CustomField'))
      },
      {
        path: '/custom-metrics',
        exact: true,
        component: lazy(() => import('src/views/CustomMetrics'))
      },
      {
        path: '/custom-metrics/:id',
        exact: true,
        component: lazy(() => import('src/views/CustomMetrics/CustomMetric'))
      },
      {
        path: '/data-profiles',
        exact: true,
        component: lazy(() => import('src/views/DataProfiles'))
      },
      {
        path: '/data-profile/:id([+-]?\\d+)',
        exact: true,
        component: lazy(() => import('src/views/DataProfiles/DataProfile'))
      },
      {
        path: '/entities',
        exact: true,
        component: lazy(() => import('src/views/Entities'))
      },
      {
        path: '/entity-details/:id([+-]?\\d+)',
        exact: true,
        component: lazy(() => import('src/views/EntityDetails'))
      },
      {
        path: '/facets',
        exact: true,
        component: lazy(() => import('src/views/Standardization/Facets'))
      },
      {
        path: '/field-value-indexes',
        exact: true,
        component: lazy(() =>
          import('src/views/Standardization/FieldValueIndex')
        )
      },
      {
        path: '/history/:id([+-]?\\d+)',
        exact: true,
        component: lazy(() => import('src/views/History'))
      },
      {
        path: '/identifier-domains',
        exact: true,
        component: lazy(() => import('src/views/IdentifierDomains'))
      },
      {
        path: '/identifier-domain/:id([+-]?\\d+)',
        exact: true,
        component: lazy(() => import('src/views/IdentifierDomains/Domain'))
      },
      {
        path: '/job-queue',
        exact: true,
        component: lazy(() => import('src/views/JobQueue'))
      },
      {
        path: '/job-entry/:id([+-]?\\d+)',
        exact: true,
        component: lazy(() => import('src/views/JobQueue/JobEntry'))
      },
      {
        path: '/logged-pairs/:vector',
        exact: true,
        component: lazy(() => import('src/views/LoggedPairs'))
      },
      {
        path: '/matching/:tab',
        exact: true,
        component: lazy(() => import('src/views/Matching'))
      },
      {
        path: '/operations/:tab',
        exact: true,
        component: lazy(() => import('src/views/Operations'))
      },
      {
        path: '/presentation',
        exact: true,
        component: PresentationView
      },
      {
        path: '/profile/:id',
        exact: true,
        component: lazy(() => import('src/views/Users/Profile'))
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: lazy(() => import('src/views/Profile'))
      },
      {
        path: '/record/:id/:previous',
        exact: true,
        component: lazy(() => import('src/views/Search/Record'))
      },
      {
        path: '/record/:id/edit/:previous',
        exact: true,
        component: lazy(() => import('src/views/Search/RecordEdit'))
      },
      {
        path: '/review-link/:id',
        exact: true,
        component: lazy(() =>
          import('src/views/Matching/ReviewLinks/RecordLinkReview')
        )
      },
      {
        path: '/report-generation',
        exact: true,
        component: lazy(() => import('src/views/Reports/Generation'))
      },
      {
        path: '/report-viewing',
        exact: true,
        component: lazy(() => import('src/views/Reports/Viewing'))
      },
      {
        path: '/review-links',
        exact: true,
        component: lazy(() => import('src/views/Matching/ReviewLinks'))
      },
      {
        path: '/roles',
        exact: true,
        component: lazy(() => import('src/views/Roles'))
      },
      {
        path: '/roles/:id',
        exact: true,
        component: lazy(() => import('src/views/Roles/Role'))
      },
      {
        path: '/search/:tab',
        exact: true,
        component: lazy(() => import('src/views/Search'))
      },
      {
        path: '/settings',
        exact: true,
        component: lazy(() => import('src/views/Settings'))
      },
      {
        path: '/settings/:tab',
        exact: true,
        component: lazy(() => import('src/views/Settings'))
      },
      {
        path: '/single-best-record',
        exact: true,
        component: lazy(() => import('src/views/SingleBestRecord'))
      },
      {
        path: '/users',
        exact: true,
        component: lazy(() => import('src/views/Users'))
      },
      {
        path: '/users/:id',
        exact: true,
        component: lazy(() => import('src/views/Users/User'))
      },
      {
        path: '/user-files',
        exact: true,
        component: lazy(() => import('src/views/UserFiles'))
      },
      {
        path: '/value-merge-operations',
        exact: true,
        component: lazy(() =>
          import('src/views/Standardization/ValueMergeOperation')
        )
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
